// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dznauhbmkcocpzonbouk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR6bmF1aGJta2NvY3B6b25ib3VrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyOTk4MTYsImV4cCI6MjA1Mjg3NTgxNn0.pq3lgv9D-a-S_AIGOcdZAAnmbhnyqLhrrbRcpLeONQc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);